<template>
  <CustomDeleteDialog
    no-close-on-backdrop
    dialogTitle="لغو کلاس گروهی"
    :dialogId="`cancel-group-class-confirmation-dialog-${dialogId}`"
    okTitle="لغو کلاس"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCancelGroupClassRequest"
  >
    <BCol>
      <p v-if="selectedGroupClass">
        آیا از کنسل کردن کلاس گروهی با
        <span style="font-weight: bold">
          {{ selectedGroupClass.studentsCount }}
        </span>
        نفر شرکت کننده اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>
<script>
export default {
  props: {
    selectedGroupClass: {
      type: Object,
    },
    dialogId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendCancelGroupClassRequest() {
      try {
        this.isOkButtonDisabled = true;
        const _this = this;
        const cancelGroupClass = new CancelGroupClass(_this);
        cancelGroupClass.setRequestParam({
          groupClassMasterId: _this.selectedGroupClass.id,
        });
        await cancelGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کنسل شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس گروهی با موفقیت کنسل شد.",
              },
            });
            _this.updateGroupClassLinkPayload = {
              groupClassMasterId: null,
              link: null,
            };
            _this.$emit("refetch");
            _this.$bvModal.hide(
              `cancel-group-class-confirmation-dialog-${this.dialogId}`
            );
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کنسل نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { CancelGroupClass } from "@/libs/Api/GroupClass";
</script>
